import {
    handleDragAndDrop,
    setItemsHeight
} from '../../../../assessments/CreateAssessmentHelpers';

export default class MatchingRun {
    /**
     * Create MatchingRun instance.
     * @param {(String|HTMLElement)} element - element to initialize class
     */
    constructor(element = 'editor-matching-activity') {
        this.element = element;
        this.classList = {
            initClass: 'js-initialized',
            editableElClass: 'matching-item span[contenteditable="true"]',
        }

        this.create();
    }

    create() {
        const { initClass } = this.classList;

        // Check if constructor got string not element
        if (typeof this.element === 'string') {
            const elements = [...document.querySelectorAll(`.${this.element}`)];

            // Create separate instances for each element
            if (elements) {
                elements.forEach(el => new MatchingRun(el));
            }
        } else {
            // Return if instance already initialized
            if (this.element.classList.contains(initClass)) {
                return;
            }

            this.init();
        }
    }

    init() {
        const { initClass } = this.classList;

        this.element.classList.add(initClass);

        handleDragAndDrop(this.element);
        this.changeHeightOfItems();
    }

    changeHeightOfItems() {
        const { editableElClass } = this.classList;
        const matchingItems = [...this.element.querySelectorAll(`.${editableElClass}`)];

        setItemsHeight(this.element);

        matchingItems.forEach(item => {
            item.addEventListener('input', () => {
                setItemsHeight(this.element);
            });
        });
    }
}
